// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._82242b{display:flex}._82242b>div{display:flex;padding-top:45%;flex:1}._82242b>div>div{flex:1}", ""]);
// Exports
exports.locals = {
	"cardContainer": "_82242b"
};
module.exports = exports;
